/**
 * スクロールヒント
 */

import ScrollHint from "scroll-hint";

export default function initScrollHint() {
  window.addEventListener("DOMContentLoaded", () => {
    const targets = document.querySelectorAll(".wp-block-flexible-table-block-table.is-scroll-on-mobile");    

    if (targets.length > 0) {
      new ScrollHint(".wp-block-flexible-table-block-table.is-scroll-on-mobile", {
        persistentHint: true,
        i18n: {
          scrollable: "スクロールできます",
        },
      });
    }
  });
}
